// import React from 'react';
import { Container, Row } from "reactstrap";
import React, { useState, useEffect } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { useHistory } from "react-router-dom";
import ko from "date-fns/locale/ko";
import "../../styles/App.css";
import TopTitle from "../../TopTitle";
import axios from "axios";
import { Collapse, Button, CardBody, Card } from "reactstrap";
import queryString from "query-string";
import {
  Select,
  currentDate,
  formatDate,
  returnDate,
  instance,
} from "../../common";
import downArrow from "../../img/eva_arrow-ios-downward-fill-1.png";
import upArrow from "../../img/eva_arrow-ios-downward-fill.png";
import whiteTel from "../../img/fluent_call-20-regular.png";
import clip from "../../img/clip.png";
import blackCalander from "../../img/calendar_b.png";
import sc_email_icon from "../../img/sc_email_icon.png";
import sc_phone_icon from "../../img/sc_phone_icon.png";
registerLocale("ko", ko);

const Example = ({
  routeName,
  inputs,
  setInputs,
  photo_before,
  photo_after,
  location,
  re_date,
  setStartDate2,
  startDate2,
  insertPushLogs,
}) => {
  const query = queryString.parse(location.search);

  const history = useHistory();
  const seq = query.seq;

  const session = JSON.parse(window.sessionStorage.result);
  const { u_login_id } = session;

  const [one, setone] = useState(false);
  const [two, setTwo] = useState(false);
  const [three, setthree] = useState(false);

  // 첫번째 collapse
  const [isOpen, setIsOpen] = useState(false);
  const toggle = (e) => {
    const { name } = e.target.dataset;
    if (name == "one") {
      setone(!one);
    }
    setIsOpen(!isOpen);
  };

  // 두번째 collapse
  const [isOpen2, setIsOpen2] = useState(false);
  const toggle2 = (e) => {
    const { name } = e.target.dataset;
    if (name == "two") {
      setTwo(!two);
    }
    setIsOpen2(!isOpen2);
  };

  // 세번째 collapse
  const [isOpen3, setIsOpen3] = useState(false);
  const toggle3 = (e) => {
    const { name } = e.target.dataset;
    if (name == "three") {
      setthree(!three);
    }
    setIsOpen3(!isOpen3);
  };

  const arrowSize = {
    width: "18px",
    position: "absolute",
    right: "0",
  };

  const textWrap = {
    borderBottom: "1px solid #c4c4c4",
    backgroundColor: "#f8f8f8",
    padding: "10px",
  };

  const telSize = {
    width: "16px",
  };

  // file upload

  const uploadImage = (e) => {
    const { id, files } = e.target;

    for (let i = 0; i < files.length; i++) {
      let formData = new FormData();
      formData.append("dir", u_login_id);
      formData.append("img", files[i]);
      fileUpload2(formData, id);
    }
    e.target.value = null;
  };

  const fileUpload = async (formdata, id, photoArray, isCheck) => {
    const fetchData = async () => {
      instance
        .post("/file/image2", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (res) {
          let path = res.data.path;
          path = path.slice(7, path.length);
          let url = "https://abys-service.co.kr:3001//" + path;
          console.log("url 이야 : ", url);
          photoArray.push(url);

          if (isCheck) {
            if (id == "file-upload") {
              setInputs({
                ...inputs,
                photo_before: [...photo_before, ...photoArray],
              });
            }
            if (id == "file-upload2") {
              setInputs({
                ...inputs,
                photo_after: [...photo_after, ...photoArray],
              });
            }
          }
        });
    };

    await fetchData();
  };
  const [tempBeforeUrl, setTempBeforeUrl] = useState("");
  const [tempAfterUrl, setTempAfterUrl] = useState("");

  useEffect(() => {
    setInputs({
      ...inputs,
      photo_before: [...photo_before, tempBeforeUrl],
    });
  }, [tempBeforeUrl]);

  useEffect(() => {
    setInputs({
      ...inputs,
      photo_after: [...photo_after, tempAfterUrl],
    });
  }, [tempAfterUrl]);

  const fileUpload2 = (formdata, id) => {
    const fetchData = async () => {
      instance
        .post("/file/image2", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (res) {
          let path = res.data.path;
          path = path.slice(7, path.length);
          let url = "https://abys-service.co.kr:3001//" + path;

          if (id == "file-upload") {
            setTempBeforeUrl(url);
          }
          if (id == "file-upload2") {
            setTempAfterUrl(url);
          }
        });
    };

    fetchData();
  };
  const ipgoFinish = (e) => {
    const fetchData = async () => {
      let common = {
        r_ipgo: currentDate(),
      };

      instance
        .post("/common/update", {
          table: routeName ? "k_reserve" : "hy_reserve",
          common: common,
          field: "seq",
          value: seq,
        })
        .then(function (res) {
          alert("정상적으로 서비스 진행일이 저장 되었습니다.");
          //history.push('/work?seq='+seq)
        });
    };

    fetchData();
  };

  const gumsuFinish = (e) => {
    const fetchData = async () => {
      let common = {
        r_gumsu: currentDate(),
        r_status: "진행중",
        photo_before: JSON.stringify(photo_before),
      };

      instance
        .post("/common/update", {
          table: routeName ? "k_reserve" : "hy_reserve",
          common: common,
          field: "seq",
          value: seq,
        })
        .then(function (res) {
          const msg = "[예약번호 : " + re_date + "]\n시공전사진 업로드 완료";
          instance.post("/users/v2/push", { msg: msg }).then(function (res) {
            insertPushLogs(msg, "시공지점");
            alert(
              "정상적으로 등록되었습니다.\n(본사로 PUSH / 진행상태 진행중으로 변경)"
            );
            //window.location.reload();
            history.goBack();
          });
        });
    };

    fetchData();
  };

  const workFinish = (e) => {
    const fetchData = async () => {
      let common = {
        r_enddate: currentDate(),
        photo_after: JSON.stringify(photo_after),
      };

      instance
        .post("/common/update", {
          table: routeName ? "k_reserve" : "hy_reserve",
          common: common,
          field: "seq",
          value: seq,
        })
        .then(function (res) {
          const msg = "[예약번호 : " + re_date + "]\n시공완료사진 업로드 완료";
          instance.post("/users/v2/push", { msg: msg }).then(function (res) {
            insertPushLogs(msg, "시공지점");
            alert("정상적으로 등록되었습니다.\n(본사로 PUSH)");
            //window.location.reload();
            history.goBack();
          });
        });
    };

    fetchData();
  };

  const [data, setData] = useState([]);
  // 데이터 조회
  const loadobj = {
    seq: seq,
  };
  const [r_ipgo, setr_ipgo] = useState("");
  const [r_gumsu, setr_gumsu] = useState("");
  const [r_enddate, setr_enddate] = useState("");
  const [href, setHref] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      instance.post(`/${routeName}/r_id`, loadobj).then(function (res) {
        console.log("reload : ", res.data);
        if (res.data.length != 0) {
          setData(res.data[0]);
          if (res.data[0].r_ipgo) {
            setr_ipgo(res.data[0].r_ipgo);
          }
          if (res.data[0].r_gumsu) {
            setr_gumsu(res.data[0].r_gumsu);
          }
          if (res.data[0].r_enddate) {
            setr_enddate(res.data[0].r_enddate);
          }

          if (res.data[0].phone) {
            setHref(res.data[0].phone);
          }
        }
      });
    };

    fetchData();
  }, []);

  const removeBefore = (i) => {
    let temp = photo_before.filter((v, index) => i !== index);
    setInputs({
      ...inputs,
      photo_before: temp,
    });
  };
  const removeAfter = (i) => {
    let temp = photo_after.filter((v, index) => i !== index);
    setInputs({
      ...inputs,
      photo_after: temp,
    });
  };

  return (
    <>
      <div>
        <div
          onClick={toggle}
          data-name="one"
          style={{ fontWeight: "bold", borderBottom: "1px solid #c4c4c4" }}
          className="py-3 position-relactive"
        >
          <span data-name="one">1. 서비스 진행일</span>

          {one ? (
            <img src={upArrow} style={arrowSize} data-name="one" />
          ) : (
            <img src={downArrow} style={arrowSize} data-name="one" />
          )}
        </div>
        <Collapse isOpen={isOpen}>
          <div style={textWrap}>
            <div className="row p-0">
              <div className="col-10 pr-2">
                <img className="icon_calender3" src={blackCalander} />
                <DatePicker
                  locale="ko"
                  dateFormat="yyyy-MM-dd"
                  className="form-control text-center text-primary culDate"
                  selected={startDate2}
                  onChange={(date) => {
                    setStartDate2(date);
                  }}
                />
              </div>
              <div className="col-2 pl-2">
                <span className="btn btn-primary" onClick={ipgoFinish}>
                  완료
                </span>
              </div>
            </div>
          </div>
        </Collapse>
      </div>
      <div>
        <div
          onClick={toggle2}
          data-name="two"
          style={{ fontWeight: "bold", borderBottom: "1px solid #c4c4c4" }}
          className="py-3 position-relactive"
        >
          <span data-name="two">2. 시공전사진</span>

          {two ? (
            <img src={upArrow} style={arrowSize} data-name="two" />
          ) : (
            <img src={downArrow} style={arrowSize} data-name="two" />
          )}
        </div>
        <Collapse isOpen={isOpen2}>
          <div style={textWrap}>
            <div className="row p-0 position-relactive">
              <span
                className="btn btn-primary"
                style={{ position: "absolute", right: "0" }}
                onClick={gumsuFinish}
              >
                완료
              </span>
            </div>
            <div>
              <label
                htmlFor="file-upload"
                className="text-center"
                onChange={uploadImage}
              >
                사진 업로드{" "}
                <img src={clip} style={{ width: "18px", marginTop: "-5px" }} />
                <input
                  id="file-upload"
                  type="file"
                  className="d-none"
                  accept="image/jpeg, image/jpg, image/png"
                  multiple
                />
              </label>
              <div>
                <div className="mt-3 position-relactive">
                  {photo_before.length != 0 ? (
                    photo_before.map((v, i) => (
                      <div
                        key={i}
                        onClick={() => {
                          removeBefore(i);
                        }}
                        className="p_midimg"
                        style={{ background: "url('" + v + "')" }}
                      ></div>
                    ))
                  ) : (
                    <p class="font-weight-bold" style={{ fontSize: "12px" }}>
                      차량 전체사진 (전면/측면/전면/번호판 식별 가능하게) 각 2장
                      이상
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Collapse>
      </div>
      <div>
        <div
          onClick={toggle3}
          data-name="three"
          style={{ fontWeight: "bold", borderBottom: "1px solid #c4c4c4" }}
          className="py-3 position-relactive"
        >
          <span data-name="three">3. 시공완료사진</span>

          {three ? (
            <img src={upArrow} style={arrowSize} data-name="three" />
          ) : (
            <img src={downArrow} style={arrowSize} data-name="three" />
          )}
        </div>
        <Collapse isOpen={isOpen3}>
          <div style={textWrap}>
            <div className="row p-0 position-relactive">
              {/* <a href={`tel:${href}`} className="btn btn-primary btn-sm mr-3"><img src={whiteTel} style={telSize}/> 고객</a> */}
              <span
                className="btn btn-primary"
                style={{ position: "absolute", right: "0" }}
                onClick={workFinish}
              >
                완료
              </span>
            </div>
            <div>
              <label htmlFor="file-upload2" onChange={uploadImage}>
                사진 업로드{" "}
                <img src={clip} style={{ width: "18px", marginTop: "-5px" }} />
                <input
                  id="file-upload2"
                  type="file"
                  className="d-none"
                  accept="image/jpeg, image/jpg, image/png"
                  multiple
                />
              </label>
              <div>
                <div className="mt-3 position-relactive">
                  {photo_after.length != 0 ? (
                    photo_after.map((v, i) => (
                      <div
                        key={i}
                        onClick={() => {
                          removeAfter(i);
                        }}
                        className="p_midimg"
                        style={{ background: "url('" + v + "')" }}
                      ></div>
                    ))
                  ) : (
                    <p class="font-weight-bold" style={{ fontSize: "12px" }}>
                      차량 전체사진 (전면/측면/전면/번호판 식별 가능하게 +
                      약품사용시 함께 촬영) 각 2장 이상
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Collapse>
      </div>
    </>
  );
};

function Work({ location }) {
  const query = queryString.parse(location.search);
  const history = useHistory();

  const seq = query.seq;
  const cate = query.cate;
  const end = query.end;
  //유저 session
  const session = JSON.parse(window.sessionStorage.result);

  const [routeName, setRoute] = useState(query.cate ? query.cate : "hy");
  //시공점 data 가져오기
  const u_sigong = session.u_sigong;

  const obj3 = {
    si_id: u_sigong,
  };

  //reserve data 가져오기
  const obj = {
    seq: seq,
  };

  const [u_login_id, setU_login_id] = useState("");
  const [contract_num, setContract_num] = useState("");
  const [si_name, setSi_name] = useState("");
  const [startDate, setStartDate] = useState("");
  const [startDate2, setStartDate2] = useState("");

  const [cateType, setCate] = useState("");

  const [inputs, setInputs] = useState({
    u_car_name: "",
    r_status: "",
    u_car_number: "",
    u_car_number2: "",
    r_ipgo: "",
    r_gumsu: "",
    r_enddate: "",
    bp_req: "",
    re_date: "",
    etc: "",
    r_reserve_date: "",
    photo_before: [],
    photo_after: [],
  });

  const [productName, setProductName] = useState("");
  const [u_info, setInfo] = useState({
    u_name: "",
    u_phone: "",
    u_address: "",
  });

  const { u_name, u_phone, u_address } = u_info;

  const {
    u_car_name,
    r_ipgo,
    r_gumsu,
    r_enddate,
    photo_before,
    photo_after,
    r_status,
    u_car_number,
    u_car_number2,
    r_reserve_date,
    etc,
    bp_req,
    re_date,
  } = inputs;

  useEffect(() => {
    instance
      .post(`/common/update`, {
        table: "fcm_push",
        common: { view_check: 1 },
        field: "table_seq",
        value: seq,
        field2: "fc_type",
        value2: routeName,
      })
      .then(function (res) {});

    const fetchData = async () => {
      instance.post(`/${routeName}/r_id`, obj).then(function (res) {
        console.log("res : ", res.data);
        if (res.data.length != 0) {
          setInputs({
            r_reserve_date: res.data[0].r_reserve_date,
            u_car_name: res.data[0].u_car_name,
            r_status: res.data[0].r_status,
            u_car_number: res.data[0].u_car_number,
            u_car_number2: res.data[0].u_car_number2,
            etc: res.data[0].etc,
            re_date: res.data[0].re_date,
            bp_req: res.data[0].bp_req,
            r_ipgo: res.data[0].r_ipgo,
            r_gumsu: res.data[0].r_gumsu,
            r_enddate: res.data[0].r_enddate,
            photo_before: res.data[0].photo_before
              ? JSON.parse(res.data[0].photo_before)
              : [],
            photo_after: res.data[0].photo_after
              ? JSON.parse(res.data[0].photo_after)
              : [],
          });

          if (routeName === "btob") {
            setInfo({
              u_name: res.data[0].u_name,
              u_phone: res.data[0].u_phone,
              u_address: res.data[0].u_address,
            });
            setProductName(res.data[0].product);
          } else if (routeName === "hy") {
            setInfo({
              u_name: res.data[0].username,
              u_phone: res.data[0].phone,
              u_address: "",
            });
          } else {
            instance
              .post("/common/condition", {
                table: "user",
                common: { u_id: res.data[0].u_seq },
              })
              .then(function (res) {
                setInfo({
                  u_name: res.data[0].u_nick,
                  u_phone: res.data[0].u_phone,
                  u_address:
                    res.data[0].u_address1 + " " + res.data[0].u_address2,
                });
              });
          }

          if (res.data[0].r_enrolldate) {
            setStartDate(returnDate(res.data[0].r_enrolldate));
          }

          if (res.data[0].r_ipgo) {
            setStartDate2(returnDate(res.data[0].r_ipgo));
          }

          if (res.data[0].cate == "btob") {
            setCate("에스씨글로벌 BtoB 서비스");
          } else if (res.data[0].cate == "k") {
            setCate("K-Solution 카케어서비스");
          } else if (res.data[0].cate == "sun") {
            setCate("썬가드 신차패키지");
          } else {
            setCate(res.data[0].cate);
          }
        }

        //setU_login_id(res.data[0])
      });

      instance.post("/sigong/id", obj3).then(function (res) {
        setSi_name(res.data[0].si_name);
      });
    };

    fetchData();
  }, [r_gumsu]);

  const TopBorderBottom = {
    borderBottom: "2px solid #111",
    fontSize: "18px",
    fontWeight: "bold",
    paddingBottom: "5px",
  };
  const inputBox = {
    border: "0",
    borderBottom: "1px solid #c4c4c4",
  };
  const borderBot = {
    borderBottom: "2px solid #111",
  };
  const btnWhite = {
    border: "1px solid #c4c4c4",
    borderRadius: "5px",
    color: "#676767",
    width: "100%",
    padding: "4px",
  };

  const mbDown = {
    marginBottom: "80px",
  };
  const redFont = {
    color: "red",
    fontSize: "12px",
  };

  const onChange = (e) => {
    const { name, value } = e.target;

    setInputs({
      ...inputs,
      [name]: value,
    });
  };

  const insert = () => {
    if (startDate) inputs.r_enrolldate = formatDate(startDate);
    if (startDate2) inputs.r_ipgo = formatDate(startDate2);

    inputs.photo_before = JSON.stringify(photo_before);
    inputs.photo_after = JSON.stringify(photo_after);

    console.log("inputs : ", inputs);
    if (!re_date) {
      alert("뒤로가기 후 다시 시도해주세요.");
    } else {
      instance
        .post(`/common/update`, {
          table: routeName ? "k_reserve" : "hy_reserve",
          common: inputs,
          field: "seq",
          value: seq,
        })
        .then(function (res) {
          alert("정상적으로 수정되었습니다.");
          history.goBack();
        });
    }
  };

  const endData = () => {
    if (startDate) inputs.r_enrolldate = formatDate(startDate);
    if (startDate2) inputs.r_ipgo = formatDate(startDate2);

    inputs.photo_before = JSON.stringify(photo_before);
    inputs.photo_after = JSON.stringify(photo_after);
    inputs.r_status = "완료";
    console.log("inputs : ", inputs);

    if (!re_date) {
      alert("뒤로가기 후 다시 시도해주세요.");
    } else {
      instance
        .post(`/common/update`, {
          table: routeName ? "k_reserve" : "hy_reserve",
          common: inputs,
          field: "seq",
          value: seq,
        })
        .then(function (res) {
          var msg = "[예약번호 : " + re_date + "] 작업완료";
          insertPushLogs(msg, "시공지점");
          alert("정상적으로 완료되었습니다.");
          history.goBack();
        });
    }
  };

  const goForm = () => {
    if (routeName == "hy_reserve") {
      window.location.replace(
        "https://abys-service.co.kr/hyundai/svform.php?seq=" + seq
      );
    } else {
      window.location.replace(
        "https://abys-service.co.kr/hyundai/svform.php?k_seq=" + seq
      );
    }
  };

  const goBojeng = () => {
    window.location.replace("http://www.zen-xero.co.kr/bbs/login.php");
  };

  const nowDate = () => {
    var now = new Date();
    var hours = now.getHours();
    var minutes = now.getMinutes();
    var seconds = now.getSeconds();
    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    return currentDate() + " " + hours + ":" + minutes + ":" + seconds;
  };
  const insertPushLogs = async (msg, type) => {
    const common = {
      fc_message: msg,
      fc_type: routeName,
      sigong_seq: u_sigong,
      fc_date: nowDate(),
      table_seq: seq,
    };

    if (type == "시공지점") {
      common.view_check = 1;
      common.view_check2 = 0;
    } else {
      common.view_check = 0;
      common.view_check2 = 1;
    }
    await instance
      .post(`/common/insert`, { table: "fcm_push", common: common })
      .then(function (res) {});
  };

  const reloadAction = () => {
    history.goBack();
  };

  const goDevice = (where) => {
    if (window.Android) {
      if (where === "sms") {
        window.Android.SendSms(u_phone);
      } else {
        window.Android.DialPhone(u_phone);
      }
    } else if (window.webkit) {
      var result = {
        u_phone: u_phone,
      };

      if (where === "sms") {
        window.webkit.messageHandlers.SendSms.postMessage(result);
      } else {
        window.webkit.messageHandlers.DialPhone.postMessage(result);
      }
    }
  };

  console.log("session : ", session);

  return (
    <>
      <Container>
        <TopTitle title="작업 내역 입력" />
        <div style={TopBorderBottom} className="mb-4">
          차량 정보 등록
        </div>

        <div style={borderBot}>
          <div className="mb-4">
            <label className="mb-3">해피콜등록일</label>
            <input
              type="text"
              style={inputBox}
              value={r_reserve_date}
              readOnly
            />
          </div>
          <div className="mb-4">
            <label className="mb-3">작업상태</label>
            <input type="text" style={inputBox} value={r_status} readOnly />
          </div>
          <div className="mb-4">
            <label className="mb-3">프로젝트명</label>
            <input type="text" style={inputBox} value={cateType} readOnly />
          </div>
          {Number(end) === 1 ? (
            <></>
          ) : (
            <>
              <div className="mb-4">
                <label className="mb-3">고객명</label>
                <input type="text" style={inputBox} value={u_name} readOnly />
              </div>
              <div className="mb-4">
                <label className="mb-3">휴대번호</label>
                {session.u_login_id === "admin4" && (
                  <>
                    <img
                      src={sc_email_icon}
                      style={{
                        width: "25px",
                        marginLeft: "10px",
                        marginRight: "7px",
                      }}
                      onClick={() => goDevice("sms")}
                    />
                    <img
                      src={sc_phone_icon}
                      style={{ width: "25px" }}
                      onClick={() => goDevice("call")}
                    />
                  </>
                )}

                <input type="text" style={inputBox} value={u_phone} readOnly />
              </div>
              <div className="mb-4">
                <label className="mb-3">고객주소</label>
                <input
                  type="text"
                  style={inputBox}
                  value={u_address}
                  readOnly
                />
              </div>
            </>
          )}

          <div className="mb-4">
            <label className="mb-3">시공업체명</label>
            <input type="text" style={inputBox} value={si_name} />
          </div>
          <div className="mb-4">
            <label className="mb-3">차종</label>
            <input
              type="text"
              style={inputBox}
              name="u_car_name"
              onChange={onChange}
              value={u_car_name}
            />
          </div>
          <div className="mb-4">
            <label className="mb-3">차량번호</label>
            <input
              type="text"
              style={inputBox}
              name="u_car_number"
              onChange={onChange}
              value={u_car_number}
            />
          </div>
          <div className="mb-4">
            <label className="mb-3">차대번호</label>
            <input
              type="text"
              style={inputBox}
              name="u_car_number2"
              onChange={onChange}
              value={u_car_number2}
            />
          </div>
          <div className="mb-4">
            <label className="mb-3">시공희망일</label>
            <div className="px-0 wrap_calender">
              <img className="icon_calender3" src={blackCalander} />
              <DatePicker
                locale="ko"
                dateFormat="yyyy-MM-dd"
                className="form-control text-center text-primary culDate"
                selected={startDate}
                onChange={(date) => {
                  setStartDate(date);
                }}
              />
            </div>
          </div>
          <div className="mb-4">
            <label className="mb-3">기타 요청사항</label>
            <input
              type="text"
              style={inputBox}
              name="bp_req"
              onChange={onChange}
              value={bp_req}
            />
          </div>
          <div className="mb-4">
            <label className="mb-3">서비스 상품</label>
            <input type="text" style={inputBox} value={productName} readOnly />
          </div>
        </div>

        <div className="upDown mb-5">
          <Example
            re_date={re_date}
            routeName={routeName}
            inputs={inputs}
            setInputs={setInputs}
            location={location}
            carmaster={u_login_id}
            photo_before={photo_before}
            photo_after={photo_after}
            setStartDate2={setStartDate2}
            startDate2={startDate2}
            insertPushLogs={insertPushLogs}
          />
        </div>
        <div className="mb-4">
          <label className="mb-3">기타</label>
          <input
            type="text"
            style={inputBox}
            name="etc"
            onChange={onChange}
            value={etc}
          />
        </div>
        <div>
          <div className="mb-5">
            <span className="btn btn-info finishBtn" onClick={() => goForm()}>
              작업의뢰서작성
            </span>
            <span
              className="btn btn-success finishBtn mt-3"
              onClick={() => goBojeng()}
            >
              보증서발행
            </span>
            <span className="btn btn-primary finishBtn mt-3" onClick={insert}>
              수정하기
            </span>
            <span
              className="btn btn-secondary finishBtn mt-3"
              onClick={endData}
            >
              완료
            </span>
            <span
              className="btn btn-secondary finishBtn mt-3"
              onClick={reloadAction}
            >
              뒤로가기
            </span>
          </div>
        </div>
      </Container>
    </>
  );
}

export default Work;
